import React from 'react';
import { t } from 'i18next';
import { DashboardContent } from '@/layouts/dashboard';
import { TiaBanner } from '@/components/custom/tia-banner';
import { Widget, WidgetBody, WidgetCount, WidgetHeader, WidgetHeaderContent, WidgetTitle } from '@/components/custom/widget';
import { JOINHA } from '@/pages/dashboard/home-teacher/teacher-character';
import StudentDataGrid from '../StudentDataGrid';
import HitsByMatterColumnChart from '../HitsByMatterColumnChart';
import ChallengeSummary from './ChallengeSummary';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';

export default function ViewChallengePlayful({ uri, challengeId, challenge, challengeData, challengeParticipants, participants, filters, orderByAccuracy, setOrderByAccuracy, hasMore, setPageNumber, loading, participantsLoading }) {
  const breadcrumbs = {
    title: 'Aprendizado Dinâmico - Desafio da Semana',
    nav: [
      {
        route: '/desafio-da-semana/resultados',
        name: 'Resultados',
        isActive: false
      },
      {
        route: uri,
        name: challenge?.title,
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      {loading ? (
        <Loader />
      ) : (
        <>
          <TiaBanner
            className="mb-6 sm:mt-24"
            image={JOINHA}
            imageAlt="Personagem do professor"
            imageHeight={215}
            imageOffset={200}
            bubbleCorner="tl"
            bubbleMaxWidth={600}
            text="Veja como seus alunos se saíram neste desafio! Confira os resultados e descubra os temas que merecem mais atenção. 📊"
          />

          <ChallengeSummary challenge={challenge} />

          <Widget className="mb-6">
            <WidgetHeader>
              <WidgetTitle>Índice de acerto por matéria</WidgetTitle>
            </WidgetHeader>

            <WidgetBody>
              <HitsByMatterColumnChart chartData={challengeData} />
            </WidgetBody>
          </Widget>

          <Widget>
            <WidgetHeader>
              <WidgetHeaderContent>
                <WidgetTitle>Participantes</WidgetTitle>
                <WidgetCount>
                  <span>Total de {challengeParticipants.length}</span>
                </WidgetCount>
              </WidgetHeaderContent>
            </WidgetHeader>

            <WidgetBody>
              <div className="filter-bar filter-bar--borderless">
                <div className="filter-bar__inner">
                  <div className="filter-bar__row">
                    <label
                      className="filter-bar__label"
                      htmlFor="playful-result-search"
                    >
                      {t('textsCommon.research')}
                    </label>
                    <input
                      className="form__control form__control--search-with-icon"
                      placeholder="Buscar por estudante"
                      type="search"
                      name="search"
                      id="playful-result-search"
                      value={filters.values.searchTerm}
                      onChange={event => filters.setFieldValue('searchTerm', event.target.value)}
                      style={{ width: '400px' }}
                    />
                  </div>
                </div>
              </div>

              {participantsLoading && challengeParticipants.length === 0 ? (
                <Loader />
              ) : participants.length > 0 ? (
                <StudentDataGrid
                  playful
                  setOrderByAccuracy={setOrderByAccuracy}
                  orderByAccuracy={orderByAccuracy}
                  hasMore={hasMore}
                  setPageNumber={setPageNumber}
                  participants={participants}
                  challengeId={challengeId}
                />
              ) : (
                <EmptyState type="data" />
              )}
            </WidgetBody>
          </Widget>
        </>
      )}
    </DashboardContent>
  );
}
